import React from "react";
import SectionHeader from "../sectionHeader";
import SectionSubHeader from "../sectionSubHeader";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";
const AboutVolto = () => {
  return (
    <>
       {/* <img src="images/about.png" /> */}
    <div className="about-volto-section">
      {/* <div className="clip-path"></div> */}
      <img className='about-banner-vector' src="/images/Union.svg" alt="vector" />
      <Container>
        <Row className="pmt-290">
          <Col lg={8}>
          <SectionHeader mainText1="About" mainText2="Volto" />
            <SectionSubHeader headerText="Combining technology, creative strategies and human-centered solutions," />
            <p className="section_descrption">
              We enable the sustainable growth of businesses to the brink of
              their potential.
            </p>
            <Link className="volto-know-more" to={"/about"}>
              Know More{" "}
              <span>
                <BsArrowRight />
              </span>
            </Link>
          </Col>
        </Row>
        <Row className="count-sec">
          <Col lg="3" md="3" sm="3">
            <div className="volto-stats">
              <h1>20+</h1>
              <div className="bar-1" style={{backgroundImage: `url('images/years-of-exp.svg')`,height: '127px'}}>
                <h3>Valuable <br></br>Clients</h3>
              </div>
              {/* <img src="images/border-line.webp" alt="volto-experience"  style={{height: '30%'}} /> */}
            </div>
          </Col>
          <Col lg="3" md="3" sm="3">
            <div className="volto-stats">
              <h1>30%</h1>
              <div className="bar-2" style={{backgroundImage: `url('images/successful-client.svg')`,height: '226px'}}>
                <h3>Overall Y-o-Y<br></br>Business Growth</h3>
              </div>
              {/* <img src="images/border-line.webp" alt="volto-experience" style={{height: '50%'}} /> */}
            </div>
          </Col>
          <Col lg="3" md="3" sm="3">
            <div className="volto-stats">
              <h1>300+</h1>
              <div className="bar-3" style={{backgroundImage: `url('images/dedicated-employee.svg')`,height: '329px'}}>
                <h3>Global <br></br>Skilled Workforce</h3>
              </div>
              {/* <img src="images/border-line.webp" alt="volto-experience" style={{height: '70%'}}  /> */}
            </div>
          </Col>
          <Col lg="3" md="3" sm="3">
            <div className="volto-stats">
              <h1>500+</h1>
              <div className="bar-4" style={{backgroundImage: `url('images/completed-project.svg')`,height: '581px'}}>
                <h3>Placements <br></br>in Last 3 Years</h3>
              </div>
              {/* <img src="images/border-line.webp" alt="volto-experience" style={{height: '100%'}}  /> */}
            </div>
          </Col>
        </Row>

        <Row className="mobile-row">
          <Col xs={6} md={3}>
            <div className="volto-stats">
            <h1>20+</h1>
            <h3>Valuable<br></br> Clients</h3>
            </div>
          </Col>
          <Col xs={6} md={3}>
          <div className="volto-stats">
            <h1>30%</h1>
            <h3>Overall Y-o-Y<br></br>Business Growth</h3>
            </div>
          </Col>
          <Col xs={6} md={3}>
          <div className="volto-stats">
            <h1>300+</h1>
            <h3>Global<br></br>Skilled Workforce</h3>
            </div>
          </Col>
          <Col xs={6} md={3}>
          <div className="volto-stats">
            <h1>500+</h1>
            <h3>Placements<br></br>in Last 3 Years</h3>
            </div>
          </Col>

        </Row>

      </Container>
    </div>
    </>
 
  );
};

export default AboutVolto;
